var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5.5H16.755L.331 19l16.424 18.5H53.5V.5zM4.376 19L18.032 3.618h32.52v30.764h-32.52L4.376 19zM34 16.883l-5.59-5.59-2.117 2.117 5.59 5.59-5.59 5.59 2.117 2.117 5.59-5.59 5.59 5.59 2.117-2.117-5.59-5.59 5.59-5.59-2.117-2.117-5.59 5.59z",
    fill: "#5C5C5C"
  })));
}
export default __webpack_public_path__ + "a78b7e03d95d87a81d2bc7014974710a.svg";
export { SvgIconDelete as ReactComponent };